/**
 * CoachPlaybook - Entry Point
 * Version: 0.6.0
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SportProvider } from './components/common/SportContext';
import { AuthProvider } from './utils/auth/AuthContext';
import { ThemeProvider } from './utils/theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SportProvider>
          <App />
        </SportProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
